import httpApi from '../api/httpApi';
import { User } from '../../models/User';

const USER_URL = '/api/v1/user';
const ADD_TO_COMPANY = '/api/v1/company/partner';

const useUser = () => {
    const getUser = () => {
        return httpApi.get<User>(USER_URL).then((resp) => {
            return resp.getData();
        });
    };

    const deleteUser = () => {
        return httpApi.del<User>(USER_URL).then((resp) => {
            return resp.getData();
        });
    };

    const updateUser = (user) => {
        return httpApi.put<User>(USER_URL, user).then((resp) => {
            return resp.getData();
        });
    };

    const addToCompany = (data) => {
        return httpApi
            .post<any>(ADD_TO_COMPANY, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    return {
        getUser,
        deleteUser,
        updateUser,
        addToCompany,
    };
};

export default useUser;
